import { Card, Tabs } from "antd";
import ContainerLayout from "../common/containerLayout";
import CityPricingTab from "./CityPricingTab";
import FareSimulationTab from "./FareSimulationTab";
import RegionalFactorsTab from "./RegionalFactorsTab";
import "./styles.css";

const InternationalPricing = () => (
  <ContainerLayout
    title="Factores internacionales"
    showNotification={false}
    defaultContainer={false}
  >
    <div className="international-pricing-page">
      <Card>
        <Tabs
          defaultActiveKey="regional"
          destroyInactiveTabPane={false}
          items={[
            {
              key: "regional",
              label: "Multiplicadores por región",
              children: <RegionalFactorsTab />,
            },
            {
              key: "cities",
              label: "Ciudades",
              children: <CityPricingTab />,
            },
            {
              key: "simulation",
              label: "Simulador de cotización",
              children: <FareSimulationTab />,
            },
          ]}
        />
      </Card>
    </div>
  </ContainerLayout>
);

export default InternationalPricing;
